"use client"

import * as React from "react"

import { cn } from "../../lib/utils"
import { VariantProps } from "class-variance-authority"
import { inputVariants } from "./new-input"

export type TextareaProps = React.ComponentProps<"textarea"> & VariantProps<typeof inputVariants>

const Textarea = React.forwardRef<
    HTMLTextAreaElement,
    TextareaProps
>(({ className, size, variant, ...props }, ref) => {
    return (
        <textarea
            className={cn(
                inputVariants({ size, variant }),
                "py-2 min-h-[60px] h-auto",
                className
            )}
            ref={ref}
            {...props}
        />
    )
})
Textarea.displayName = "Textarea"

export { Textarea }
